(ns frontend.view.reports.custom.alj-2.active-deals-charts
  (:require
   [common.util :as cu]
   [frontend.view.reports.custom.alj :as alj]
   [frontend.view.reports.custom.alj-2.alj-components :as alj-components]
   [frontend.view.reports.custom.alj-2.utils :as alj-utils]))




(defn active-deals-bu-ticket-size
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{:entity.type/oppo} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [deals (->> (alj/all-deals)
                       (cu/filter-by :oppo/status :oppo.status/ok)
                       (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo))]
        [alj-components/deals-by-business-unit
         {:deals           deals
          :view-name       "Active deals by SBU - $M"
          :x-axis-type     :ticket-size-sum
          :date-state-atom date-state-atom}]))))

(defn active-deals-bu-number-of-deals
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{:entity.type/oppo} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [deals (->> (alj/all-deals)
                       (cu/filter-by :oppo/status :oppo.status/ok)
                       (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo))]
        [alj-components/deals-by-business-unit
         {:deals           deals
          :view-name       "Active deals by SBU - Count of Deals"
          :x-axis-type     :number-of-deals
          :date-state-atom date-state-atom}]))))


(defn active-deals-deal-type-ticket-size
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{:entity.type/oppo} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [deals (->> (alj/all-deals)
                       (cu/filter-by :oppo/status :oppo.status/ok)
                       (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo))]

        [alj-components/deals-by-deal-type
         {:deals           deals
          :view-name       "Active deals by deal type - $M"
          :x-axis-type     :ticket-size-sum
          :date-state-atom date-state-atom}]))))


(defn active-deals-deal-type-number-of-deals
  [{:keys [state]}]
  (let [date-state-atom (alj-utils/date-state-defaults
                         state
                         [[:date-created #{:entity.type/oppo} [:entity.type/oppo]]])]
    (fn [{:keys [state]}]
      (let [deals (->> (alj/all-deals)
                       (cu/filter-by :oppo/status :oppo.status/ok)
                       (alj-utils/deals-in-date-range-if-configured :common/created-on @date-state-atom :date-created :entity.type/oppo))]
        [alj-components/deals-by-deal-type
         {:deals           deals
          :view-name       "Active deals by deal type - Count of Deals"
          :x-axis-type     :number-of-deals
          :date-state-atom date-state-atom}]))))
